import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import Center from '../../../packages/kiti/components/helpers/Center'
import Container from '../../../components/structure/Container'
import ControlledModal from '../../../components/modals/ControlledModal'
import CreateNewIntegrationButton from './CreateNewIntegrationButton'
import IntegrationsList from './IntegrationsList'
import IntegrationsLoader from './_load/IntegrationsLoader'
import ModalHeader from './ModalHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const SelectIntegrationServiceModal = props => {
  return (
    <ControlledModal fullScreen {...props}>
      <ModalHeader />

      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={4} />

      <Container maxWidth="32rem">
        <IntegrationsLoader>
          <IntegrationsList />
        </IntegrationsLoader>

        <Separator weight={6} />

        <Center>
          <CreateNewIntegrationButton />
        </Center>
      </Container>
    </ControlledModal>
  )
}

export default SelectIntegrationServiceModal
